package ru.it_mozaika.sender.js.application.frames.triggers.categories

import io.ktor.client.call.*
import io.ktor.http.*
import js.core.ReadonlyRecord
import js.core.jso
import mui.material.*
import mui.system.responsive
import mui.system.sx
import oldcomponents.NotyType
import oldcomponents.showNotification
import react.*
import ru.it_mozaika.components.filterOffButton
import ru.it_mozaika.components.commonTableSkeletonFrame
import ru.it_mozaika.sender.common.models.ColumnsFilter
import ru.it_mozaika.sender.common.models.TriggerCategory
import ru.it_mozaika.sender.js.application.Http
import ru.it_mozaika.sender.js.application.frames.MainCard
import tanstack.react.table.useReactTable
import tanstack.table.core.*
import web.cssom.*
import kotlinx.datetime.internal.JSJoda.Duration
import mui.material.styles.Theme
import mui.material.styles.useTheme
import ru.it_mozaika.components.AvatarButton
import ru.it_mozaika.sender.js.application.components.triggers.categories.categoriesDeleteDialog
import ru.it_mozaika.sender.js.application.components.triggers.categories.triggersCategoryDialog

val triggersCategoryListFrame = VFC {
    val (categories, setCategories) = useState(listOf<TriggerCategory>())
    val (showDialog, setShowDialog) = useState(false)
    var (columnVisibility, setColumnVisibility) = useState<ReadonlyRecord<String, Boolean>>(jso {})
    val (columnOrder, setColumnOrder) = useState<ColumnOrderState>(jso {})
    val (selectedProperty, setSelectedProperty) = useState("")
    val (checkedProperties, setCheckedProperties) = useState(listOf<String>())
    val (propertiesFilter, setPropertiesFilter) = useState<List<ColumnsFilter>>(listOf())
    val (selectedCategories, setSelectedCategories) = useState<List<TriggerCategory>>(listOf())
    val tableColumns = listOf("ID", "Наименование", "Категория", "Статус")
    val (showFilter, setShowFilter) = useState(false)
    val (selectedTriggersCategory, setSelectedTriggerCategory) = useState<TriggerCategory>()
    val (showDeleteDialog, setShowDeleteDialog) = useState(false)

    fun getCategories() {
        Http.get("/triggers/categories") { response ->
            when (response.status) {
                HttpStatusCode.OK -> {
                    setCategories(response.body<List<TriggerCategory>>())
                }

                HttpStatusCode.Forbidden -> showNotification("Доступ запрещен!", NotyType.Error)
                else -> showNotification("Ошибка: ${response.status}", NotyType.Error)
            }
        }
    }
    useEffectOnce {
        getCategories()
    }

    val table = useReactTable<TriggerCategory>(
        options = jso {
            columns = useMemo(tableColumns) {
                tableColumns.map { column ->
                    jso<ColumnDef<TriggerCategory, Any?>> {
                        accessorFn = { category, _ ->
                            when (column) {
                                "ID" -> category.id
                                "Наименование" -> category.name
                                "Ограничение количества" -> category.mailsLimit
                                "Период ограничения" -> {
                                    var period = category.limitPeriod
                                    val days = period / Duration.ofDays(1).seconds().toLong()
                                    period -= days * Duration.ofDays(1).seconds().toLong()
                                    val hours = period / Duration.ofHours(1).seconds().toLong()
                                    period -= hours * Duration.ofHours(1).seconds().toLong()
                                    val minutes = period / Duration.ofMinutes(1).seconds().toLong()
                                    period -= minutes * Duration.ofMinutes(1).seconds().toLong()
                                    val text = StringBuilder()
                                    if (days > 0L) {
                                        text.append("$days дн. ")
                                    }
                                    if (hours > 0L) {
                                        text.append("$hours ч. ")
                                    }
                                    if (minutes > 0L) {
                                        text.append("$minutes м. ")
                                    }
                                    if (period > 0L) {
                                        text.append("$period с. ")
                                    }
                                    text.toString()
                                }

                                else -> ""
                            }
                        }
                        cell = ColumnDefTemplate { context ->
                            val value = context.getValue().toString()
                            Box.create {
                                +value
                            }
                        }
                        id = column
                        header = StringOrTemplateHeader(column)
                    }
                }
            }.toTypedArray()
            this.data = useMemo(categories) { categories.toTypedArray() }
            this.state = jso {
                this.columnVisibility = columnVisibility
                this.columnOrder = columnOrder
            }
            this.onColumnVisibilityChange = {
                columnVisibility = it.unsafeCast<ReadonlyRecord<String, Boolean>>()
                setColumnVisibility(it.unsafeCast<ReadonlyRecord<String, Boolean>>())
            }
            this.onColumnOrderChange = {
                setColumnOrder(it.unsafeCast<Array<String>>())
            }
            this.getCoreRowModel = getCoreRowModel()
            this.debugTable = true
            this.debugHeaders = true
            this.debugColumns = true
        }
    )
    triggersCategoryDialog {
        isOpen = showDialog
        this.onClose = {
            setShowDialog(false)
            setSelectedTriggerCategory(null)
            getCategories()

        }
        this.selected = selectedTriggersCategory
    }
    categoriesDeleteDialog {
        isOpen = showDeleteDialog
        selected = selectedCategories
        onClose = {
            setShowDeleteDialog(false)
            setSelectedCategories(listOf())
            getCategories()
        }
    }

    MainCard {
        title = "Категории триггеров"
        actions = Stack.create {
            this.direction = responsive(StackDirection.row)
            this.divider = Divider.create {
                orientation = Orientation.vertical
            }
            asDynamic().spacing = 2
            sx {
                this.width = 100.pct
                border = 2.px
                this.alignItems = AlignItems.center
                this.justifyContent = JustifyContent.flexStart
            }
            AvatarButton {
                onClick = {
                    setSelectedTriggerCategory(null)
                    setShowDialog(true)
                }
                tooltipTitle = "Создать"
                mui.icons.material.AddCircleOutlineSharp()
            }
        }
        commonTableSkeletonFrame {
            showCheckBox = true
            currentSelected = selectedCategories.map { it.id }
            toolbarActions = Stack.create {
                this.direction = responsive(StackDirection.row)
                this.divider = Divider.create {
                    orientation = Orientation.vertical
                }
                asDynamic().spacing = 2
                sx {
                    this.width = 100.pct
                    border = 2.px
                    this.alignItems = AlignItems.center
                    this.justifyContent = JustifyContent.flexStart
                }
                if (checkedProperties.isNotEmpty()) {
                    filterOffButton {
                        this.propertiesFilter = checkedProperties
                        this.handleOnFilterOffClick = {
                            setCheckedProperties(listOf())
                            setPropertiesFilter(listOf())
                        }
                    }
                }
                if (selectedCategories.isNotEmpty()) {
                    AvatarButton {
                        onClick = {
                            setShowDeleteDialog(true)
                        }
                        tooltipTitle = "Удалить"
                        palettecolor = useTheme<Theme>().palette.error
                        mui.icons.material.DeleteForeverSharp()
                    }
                }
            }
            this.label = "triggers-category-list"
            this.propertiesFilter = propertiesFilter
            this.columnId = "ID"
            this.table = table
            this.onDoubleClickHandler = { id ->
                val selected = categories.find { it.id == id }
                setSelectedTriggerCategory(selected)
                setShowDialog(true)
            }
            this.onPropertySelect = { property ->
                setSelectedProperty(property)
                if (showFilter) setShowFilter(false) else setShowFilter(true)
            }
            this.onSelectionChanged = { newSelected ->
                val newList = newSelected.mapNotNull { id ->
                    categories.associateBy { it.id }[id]
                }
                setSelectedCategories(newList)
            }
        }
    }
}